/* Cta1.js */
/* @author: anghello */

import React from 'react';
import Strings from '../../../translations/Translations';
import './cta1.scss';
import { useHistory } from 'react-router-dom';

const actions = [
  Strings('create_something_amazing_today'),
  Strings('craft_something_amazing'),
  Strings('innovate_and_create_today'),
  Strings('inspire_with_your_creativity'),
  Strings('design_something_amazing'),
  Strings('dream_big_and_create_today'),
  Strings('make_today_unforgettable'),
  Strings('let_your_creativity_shine'),
  Strings('be_creative_and_make_today_great'),
  Strings('imagine_and_innovate_today'),
  Strings('bring_your_ideas_to_life'),
  Strings('spark_creativity_today'),
  Strings('create_something_beautiful'),
  Strings('explore_your_creativity'),
  Strings('design_your_masterpiece_today'),
  Strings('make_magic_happen_today'),
  Strings('dare_to_create_today'),
  Strings('craft_your_dreams_today'),
  Strings('express_yourself_through_creation'),
  Strings('turn_ideas_into_reality'),
  Strings('unleash_your_creativity'),
  Strings('inspire_others_with_your_creations'),
  Strings('design_with_passion'),
  Strings('innovate_and_inspire_today'),
  Strings('let_your_creativity_bloom'),
  Strings('design_a_better_world_today'),
  Strings('let_creativity_be_your_guide'),
  Strings('embrace_creativity_and_shine'),
  Strings('make_today_extraordinary'),
  Strings('create_wonders_today'),
  Strings('explore_new_possibilities_today'),
  Strings('build_something_amazing_today')
];

export default function Cta1() {
  const date = new Date();
  const dayOfTheMonth = date.getDate();
  const ctaString = actions[dayOfTheMonth-1];
  const ctaClass = `gradient-35`;

  const history = useHistory();

  return (
    <div className='row justify-content-center'>
      <div className='col-sm-12'>
        <div className={`cta1 ${ctaClass}`}>
          <h3>{ctaString}</h3>

          <div className='buttons'>
            <button onClick={() => history.push('/create')}>
              <span>{Strings('make_your_link_page')}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}